import React from "react";

function CdAndLpButtonArtist({ artist }) {
  const artistStr = artist.replaceAll(' ', '-').replaceAll('/', '');
  return (
    <a href={`https://www.cdandlp.com/en/${artistStr}/artist/?affilie=dreamchimney&utm_source=www.dreamchimney.com&utm_medium=button&utm_campaign=affiliation`} target="_blank"><img src="https://www.cdandlp.com/images/affiliation/1/boutons/buy-it-on-cdandlp-en-200x49.png" alt="Buy from CDandLP" /></a>
  );
}

function CdAndLpButton({ artist, album }) {
  const artistStr = artist.replaceAll(' ', '-').replaceAll('/', '');
  if (!album) {
    return (<CdAndLpButtonArtist artist={artistStr} />)
  }
  const albumStr = album.replaceAll(' ', '-')
    .replaceAll('?', '')
    .replaceAll('/', '')
    .replaceAll('"', '')
    .replaceAll(')', '')
    .replaceAll('(', '')
    .replaceAll('&', '');
  return (
    <a href={`https://www.cdandlp.com/en/${artistStr}/${albumStr}/album/?affilie=dreamchimney&utm_source=www.dreamchimney.com&utm_medium=button&utm_campaign=affiliation`} target="_blank"><img src="https://www.cdandlp.com/images/affiliation/1/boutons/buy-it-on-cdandlp-en-200x49.png" alt="Buy from CDandLP" /></a>
  );
}

export { CdAndLpButton, CdAndLpButtonArtist };
